import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin, Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { ExpiryWarningService } from "src/app/services/expiry/expiry-warning.service";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { MessagingService } from "../../messaging/messaging.service";
import { CommonService } from "../../services/common.service";
import { MessagingStructure } from "../../services/features-by-plan/interface/messaging";
import { DateType, DATE_FORMATS } from "./../../services/utils";
import { AlertService } from "src/app/services/alert.service";

@Component({
  selector: "app-sent-message",
  templateUrl: "./sent-message.component.html",
  styleUrls: ["./sent-message.component.scss"],
})
export class SentMessageComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  sent_camp_list: any = [];
  sent_camp_list_len: number;
  sent_camp_list_len_filter: number;
  outlet_id: string;
  items_per_page: number = 25;
  p: number = 1;
  totalsentCount: number;
  show_selected_list: Boolean = false;
  DATE_FORMATS = DATE_FORMATS;
  contact_id: String;
  pagePerItemList: any = GlobalVariable.ITEMS_PER_PAGE_LIST;
  collection: any;
  item_list: any = [];
  show_stats: boolean = true;
  type_list: any = [];
  followed_list: any;
  sent_type: string = "";
  tag_member: string = "";
  is_followed: string = "";
  show_component: Boolean;
  review_start_date: any;
  public todayDate: any = new Date();
  filterisempty: Boolean = false;
  campaign_id: String = "None";
  filterDates: any;
  permissions: any;
  promotionInfo: string = "all";
  isAccessMenu: any;
  downloading: boolean;
  start: any;
  end: any;
  is_messaging_blocked: any;
  messaging_warning_text: any = "";
  startAt: DateType;
  messagingFeature: MessagingStructure = this.messagingService.messagingFeature;
  channel: string = "";
  searchText: string = "";
  private searchText$: Subject<string> = new Subject();
  statusSelected: string = "";
  statusList = [];
  promotionalChannels = [];
  transactionalChannels = [];
  allChannels = [];
  channelList = [];

  constructor(
    private modalService: NgbModal,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: DataService,
    private toastrService: ToastrService,
    public formBuilder: FormBuilder,
    private commonservice: CommonService,
    private alertService: AlertService,
    private messagingService: MessagingService,
    private expiryWarningService: ExpiryWarningService
  ) {}

  ngOnInit() {
    if (this.getSentType) {
      if (this.getSentType.toUpperCase() == "TRANSACTIONAL") {
        this.promotionInfo = "transactional";
      } else {
        this.promotionInfo = "promotional";
      }
    } else {
      this.promotionInfo = "all";
    }

    this.outlet_id = this.storage.get("outlet_id");
    this.isAccessMenu = this.storage.get("access").main_menu;
    this.loading = true;
    this.getMessagingMetaData();
    this.commonservice.sent_message_tab_selection.subscribe((result) => {
      if (result === "SENTDRAFT") {
        this.sentMessageList();
      }
    });
    this.searchText$.pipe(debounceTime(500)).subscribe(() => {
      this.sentMessageList();
    });

    this.startAt = this.commonservice.onDateFilter();
    console.log(this.startAt);
  }

  get getSentType() {
    return this.route.snapshot.paramMap.get("type") ?? "";
  }

  onSearch() {
    if (
      (this.searchText && this.searchText.length > 2) ||
      !this.searchText.length
    ) {
      this.p = 1;
      this.searchText$.next();
    }
  }

  viewSharedMessage(campaign_id) {
    this.router.navigate([`messaging/view-analytics/${campaign_id}`]);
  }


  downloadUploadedFile(post) {
    window.open(post.s3_url, "_blank");
    window.setTimeout(function () {
      this.close();
    }, 1000);
  }
  onPromotionInfoChange() {
    if (this.promotionInfo == "all") {
      this.channelList = [];
      this.channelList = this.commonservice.deepCloneArray(this.allChannels);
    } else if (this.promotionInfo == "transactional") {
      this.channelList = [];
      this.channelList = this.commonservice.deepCloneArray(
        this.transactionalChannels
      );
    } else {
      this.channelList = [];
      this.channelList = this.commonservice.deepCloneArray(
        this.promotionalChannels
      );
    }
    this.channel = "all";
    this.p = 1;
    this.sentMessageList();
  }

  redirectToCustomerList(customerListId: string) {
    customerListId !== null &&
      this.messagingService.redirectToCustomerList(customerListId);
  }

  onDateFilterChange() {
    const dat1 = moment(this.filterDates[0]).format("YYYY-MM-DD");
    this.start = dat1;

    const dat2 = moment(this.filterDates[1]).format("YYYY-MM-DD");
    this.end = dat2;

    this.sentMessageList();
  }
  onPostTypeFilter(channel: string) {
    this.channel = channel;
    this.sentMessageList();
  }
  resetDateFilter() {
    this.p = 1;
    this.filterDates = undefined;
    this.start = undefined;
    this.end = undefined;
    this.searchText = "";
    this.channel = "";
    this.statusSelected = "";
    this.promotionInfo = "all";
    this.channelList = [];
    this.channelList = this.commonservice.deepCloneArray(this.allChannels);
    this.sentMessageList();
  }

  downloadReport() {
    let start: string = "";
    let end: string = "";
    if (this.filterDates !== undefined) {
      const dat1 = moment(this.filterDates[0]).format("YYYY-MM-DD");
      start = dat1;
      const dat2 = moment(this.filterDates[1]).format("YYYY-MM-DD");
      end = dat2;
    }

    let res: Response;
    this.downloading = true;

    this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.TRANSACTIONAL_DOWNLOAD_REPORT(this.outlet_id),
      start: start || null,
      end: end || null,
      source: this.channel && this.channel !== "all" ? this.channel : null,
      keyword: this.searchText || null,
      status:
        this.statusSelected && this.statusSelected !== "ALL"
          ? this.statusSelected
          : null,
    }).subscribe((data) => {
      res = data;
      if (res.code === 200 || res.code == 201) {
        this.downloading = false;
        this.toastrService.success(res.data["message"]);
        // window.open(res.data['url'], '_blank');
      }
    });
  }

  onPageChange(event) {
    this.p = event;
    this.sentMessageList();
  }
  itemsPerPageChange() {
    this.onPageChange(this.p);
  }

  private getMessagingMetaData() {
    this.messagingService.getMessagingMetaDataAPI().subscribe((res) => {
      if (res.code == 200) {
        this.statusList = res?.data?.status_filters;
        this.promotionalChannels = res?.data?.promotional_channels;
        this.transactionalChannels = res?.data?.transactional_channels;
        this.allChannels = res?.data?.all_channels;

        this.allChannels = this.allChannels.filter((element: any) => {
          return element?.value !== "Email";
        });

        this.promotionalChannels = this.promotionalChannels.filter(
          (element: any) => {
            return element?.value !== "Email";
          }
        );

        this.transactionalChannels = this.transactionalChannels.filter(
          (element: any) => {
            return element?.value !== "Email";
          }
        );

        if (this.promotionInfo == "all") {
          this.channelList = [];
          this.channelList = this.commonservice.deepCloneArray(
            this.allChannels
          );
        } else if (this.promotionInfo == "transactional") {
          this.channelList = [];
          this.channelList = this.commonservice.deepCloneArray(
            this.transactionalChannels
          );
        } else {
          this.channelList = [];
          this.channelList = this.commonservice.deepCloneArray(
            this.promotionalChannels
          );
        }
        this.sentMessageList();
      }
    });
  }

  sentMessageList() {
    let res: Response;

    const sent_campaign = this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.MESSAGING_SENT_FILTER(
        this.outlet_id,
        this.promotionInfo
      ),
      page: this.p.toString(),
      size: this.items_per_page.toString(),
      start: this.start == undefined ? null : this.start,
      end: this.end == undefined ? null : this.end,
      channel: this.channel && this.channel !== "all" ? this.channel : null,
      keyword: this.searchText || null,
      status:
        this.statusSelected && this.statusSelected !== "ALL"
          ? this.statusSelected
          : null,
    });
    sent_campaign.subscribe((data: Response) => {
      res = data;
      this.sent_camp_list = res.data["messages"];
      this.sent_camp_list_len = res.data["messages"].length;
      this.permissions = res.data["permissions"];
      this.totalsentCount = res.data["total_sent_message_count"];
      this.messagingService.setTotalCount({
        count: this.totalsentCount,
        type: "SENT",
        product: "TRANSACTIONAL",
      });
      this.loading = false;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.checkExpiry();
    }, 500);
  }
  checkExpiry() {
    let divContainer: HTMLElement | null =
      document.querySelector("#expiry-modal");
    const { isExpired, expiryWarningText } =
      this.expiryWarningService.checkExpiryBasedOnProduct(
        "MESSAGING",
        divContainer
      );
    this.is_messaging_blocked = isExpired;
    this.messaging_warning_text = expiryWarningText;
  }

  public deleteBanner() {
    this.messaging_warning_text = "";
  }
  // Open delete popup
  // deleteDraftList(campaignid, deleteModel) {
  //   this.campaign_id = campaignid;
  //   this.modalService.open(deleteModel, {
  //     size: "lg",
  //     centered: true,
  //   });
  // }

  // deleteDraft() {
  //   let res: Response;
  //   const data_json: any = {
  //     message_id: this.campaign_id,
  //   };
  //   const data_service = this.HttpService.put(
  //     this.BASE_URL.MESSAGING_SMS_DELETE(this.outlet_id),
  //     data_json
  //   );
  //   data_service.subscribe(
  //     (data: Response) => {
  //       res = data;
  //     },
  //     (error) => {
  //       this.campModalClose();
  //       this.toastrService.error(error.error.message);
  //     },
  //     () => {
  //       if (res.code === 200 || res.code === 201) {
  //         this.toastrService.success(res.data["message"]);
  //         this.sentMessageList();
  //         this.campModalClose();
  //       } else {
  //         this.campModalClose();
  //         this.toastrService.error(res.data["message"]);
  //       }
  //     }
  //   );
  // }

  // model popup close
  campModalClose() {
    this.modalService.dismissAll("content");
  }

  deleteScheduleMessage(campaignid) {
    this.alertService
      .alertWithDeleteImage(
        "Delete Scheduled Message",
        "Are you sure you want to delete scheduled message?",
        "Delete"
      )
      .then((data) => {
        if (data.isConfirmed) {
          this.deleteSentMessage(campaignid);
        }
      });
  }

  deleteSentMessage(campaignId) {
    let res: Response;
    this.messagingService.deleteDraftMessage(campaignId).subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {
        if (res.code === 200 || res.code === 201) {
          this.modalService.dismissAll();
          this.toastrService.success(res.data["message"]);
          this.sentMessageList();
        }
      }
    );
  }

  downloadCampaignData(msgId: string) {
    this.messagingService.downloadCampaignData(msgId).subscribe(
      (data: Response) => {
        this.toastrService.success(data.data["message"]);
      },
      (error) => {
        this.toastrService.error(error.error.message);
      }
    );
  }

  editScheduleMessage(msgId: string) {
    this.commonservice.onCampaignEdit.next(msgId);
    this.router.navigate([`/messaging/edit/${msgId}`]);
  }
}
